import React, { Component } from 'react';
import { Motion, spring, presets } from "react-motion";

class QuestionBox extends Component {
    constructor() {
        super();
        this.state = {
            visible: true,
            click: ""
        }
        this.handleYes = this.handleYes.bind(this);
        this.handleNo = this.handleNo.bind(this);
        this.yesBtn = null;


    }
    componentWillMount() {
        this.internalValidate(this.props);
    }
    internalValidate(props) {
        if (!props.questionMsg) {
            throw new Error("Question Box need to have a questionMsg prop that should contain quetion string");
        }
        if (!props.yesCallBack) {
            throw new Error("Question Box need to have a yesCallBack prop .");
        }

        if (!props.noCallBack) {
            throw new Error("Question Box need to have a noCallBack prop .");
        }
    }

    handleYes() {
        //this.props.yesCallBack();
        this.setState({ visible: false, click: "yes" });

    }
    handleNo() {
        //this.props.noCallBack();
        this.setState({ visible: false, click: "no" });
    }

    handleRest() {

        if (this.state.click === "yes") {
            this.props.yesCallBack();
            return;
        }

        if (this.state.click === "no") {
            this.props.noCallBack();
        }
    }

    componentDidMount() {
        this.yesBtn.focus();
    }

    render() {
        return (
            <Motion defaultStyle={{ x: 0 }} style={{ x: this.state.visible ? spring(1, presets.stiff) : spring(0, { stiffness: 210, damping: 20, precision: 1 }) }} onRest={this.handleRest.bind(this)}>

                {({ x }) => {

                    return (
                        <div id="questionBoxContainer" >
                            <div id="questionBox" style={{ opacity: x, transform: `scale(${x})` }}>
                                <div className="bar"></div>
                                <div className="questionMsg">
                                    <i className="fa fa-question-circle-o questionIcon" aria-hidden="true"></i>
                                    <p className="msg">{this.props.questionMsg}</p>
                                </div>
                                <div className="pp">
                                    <button className="btn btnOk" onClick={this.handleYes} ref={(yesBtn) => this.yesBtn = yesBtn}>Yes</button>
                                    <button className="btn btnOk" onClick={this.handleNo}>No</button>
                                </div>
                            </div>
                            <audio autoPlay="autoplay">
                                <source src="/chord.wav" type="audio/wav" />
                            </audio>
                            <div className="overlay" onClick={this.handleNo}></div>
                        </div>
                    );
                }}
            </Motion>

        );
    }

}

export default QuestionBox;


// WEBPACK FOOTER //
// ./src/jsx/components/utility/question-box.jsx